export default "__VITE_ASSET__CWyT1IBu__"